(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compact-closing-offer"] && !Shopify.designMode) return;
  try {
    
function syncClosingOffers(){document.querySelectorAll('.compact-closing').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const data=JSON.parse(section.querySelector('.compact-closing__variants').textContent),button=section.querySelector('.compact-closing__button'),source=document.querySelector('#product-section product-price');const update=()=>{const id=document.querySelector('#product-section form input[name="id"]')?.value;const v=data[id];if(v)button.textContent=button.dataset.label.replace('[discount]',v.compare>v.price?Math.round((v.compare-v.price)*100/v.compare):0)};if(source)new MutationObserver(update).observe(source,{subtree:true,childList:true,characterData:true});update()})}syncClosingOffers();document.addEventListener('shopify:section:load',syncClosingOffers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-tabbed-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-tabbed-reviews]').forEach((section) => {
    const tabs = section.querySelectorAll('[data-review-tab]');
    const panels = section.querySelectorAll('[data-review-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.reviewTab;

        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.reviewPanel !== target;
        });
      });
      tab.addEventListener('keydown', (event) => {
        const index = Array.from(tabs).indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        tabs[next].focus();
        tabs[next].click();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
